import * as React from 'react';
import { PlayerIcon } from './Icons';
import * as styles from './VideoPreview.css';

export interface IVideoPreviewProps {
  url: string;
  fallback?: string;
  onClick?(event: React.MouseEvent<HTMLDivElement>): void;
}

export function VideoPreview({ url, fallback, onClick }: IVideoPreviewProps) {
  const ref = React.useRef<HTMLImageElement>(null);
  const [imgUrl, setImgUrl] = React.useState(url);

  React.useEffect(() => {
    /* Сначала пытаемся отобразить фото более высого качества (1280*720),
      оно существует не для всех видео, если youtube присылает маленькую заглушку,
      пытаемся загрузить картинку меньше
    */

    if (ref.current && ref.current.naturalWidth === 120) {
      if (fallback) {
        setImgUrl(fallback);
      }
    }
  }, [fallback]);

  const onLoadError = () => {
    if (fallback) {
      setImgUrl(fallback);
    }
  };

  return (
    <div
      data-testid="VideoPreview"
      className={styles['container']}
      style={{ backgroundImage: `url(${imgUrl})` }}
      onClick={onClick}
    >
      <PlayerIcon />
      <img ref={ref} className={styles['img']} src={url} onError={onLoadError} alt="" />
    </div>
  );
}
